import { useDispatch, useSelector } from 'react-redux';
import { useState } from 'react';
import A from './ActionCreators';
import G from './Getters';
import { FIGURE_PANELS } from './RecordTypes';
import MolecularWeightSideOption from './MolecularWeightSideOption';
import Id from './IdFactory';
import Tooltip from '@material-ui/core/Tooltip';


const opposite = { right:"left", left:"right" };

export default function GelPanelSpecification({
  setSelectedFigurePanelContext, setTargetDirectoryOfNewFigurePanel, targetDirectoryOfNewFigurePanel
}){

  const [ selectedMwSide, setSelectedMwSide ] = useState("right");

  let dispatch = useDispatch();
  const [lanes, setLanes] = useState(12);

  const shouldCreateFigureWithGuidelines = useSelector(state => G.getItemCount(state,{type:FIGURE_PANELS}) < 4);


  return (

    <div class="" style={{
      
      fontSize:24, 
      textAlign:'center',
    }}>


    
    
    <h4 style={{marginBottom:20}}>
<Tooltip placement={"top"} title={"How many sample bands will be in each crop?"}>  
    <div class="sg-row">
        Noº of Lanes

    </div>

    </Tooltip>
      </h4>
    


    
    {false && <div style={{fontSize:16, margin:20}}>
        <i></i>
      </div>}
      <div>
        <input style={{fontSize:24}} value={lanes} onChange={e => setLanes(Number(e.target.value))} style={{width:100}} min={1} type="number"/>
      </div>

      {true && <><div style={{fontSize:16,marginTop:40,}}>
        <h4 style={{marginBottom:20}}>Molecular Weight Layout</h4>
      </div>
        <MolecularWeightSideOption {...{
          side:"left",
          selectedMwSide,
          setSelectedMwSide
        }}/>



        <MolecularWeightSideOption {...{
          side:"right",
          selectedMwSide,
          setSelectedMwSide
        }}/>
      </>
      }


      <button 
    style={{marginTop:50}}
        button="acceptFigurePanelSettings"
        onClick={() => {
          let _id = Id();

          setTargetDirectoryOfNewFigurePanel(false);
          //setSelectedFigurePanelContext({_id, editing:true});

          dispatch(A.createItem({
            type:FIGURE_PANELS,
            figurePanelType:'westernBlot',
            _id,
            args:{
              left:1,
              gel:lanes,
              right:1,
              labelLayout:{
                [selectedMwSide]:["mw"],
                [opposite[selectedMwSide]]:["crop"]
              },
              includeGuides:shouldCreateFigureWithGuidelines,
              template:(targetDirectoryOfNewFigurePanel === "figurePanelTemplates")
            },
            onSuccess:[
              A.setSelectedFigurePanelContext({
                context:{
                  _id,
                  figurePanelId:_id
                }
              })
            ]
          }))
        }}


        class="btn btn-primary">Create Figure</button>
    </div>
  )
}
